import styled, { keyframes } from 'styled-components/macro'

import { theme, mediaLandscape } from 'styled'

export const Root = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 54, 87, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s;

  &:after {
    content: '';
    position: absolute;
    left: 16px;
    right: 16px;
    top: 16px;
    bottom: 16px;
    background-color: ${theme.colors.primary};
    z-index: -1;
  }

  ${mediaLandscape`
    opacity: 1;
  `};
`

export const AnimationBox = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 40px;

  > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

const deviceAnimate = keyframes`
  0%, 50%{
    transform: rotate(0);
  }
  70%, 100%{
    transform: rotate(90deg);
  }
`
export const DeviceBox = styled.div`
  > * {
    animation: ${deviceAnimate} 2s linear infinite;
  }
`

const arrowAnimate = keyframes`
  0%, 20%{
    transform: rotate(0);
  }
  40%, 100%{
    transform: rotate(180deg);
  }
`
export const ArrowsBox = styled.div`
  > * {
    animation: ${arrowAnimate} 2s linear infinite;
  }
`
